import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from "react-router-dom";

// Layouts principales
import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut';
import PageLayaut from '../Layouts/PageLayaut';

// Componente de carga visual ligero para transiciones SPA
const LazyFallback = () => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        width: '100%'
    }}>
        <div style={{
            width: '36px',
            height: '36px',
            border: '3px solid rgba(37, 99, 235, 0.15)',
            borderTop: '3px solid #2563eb',
            borderRadius: '50%',
            animation: 'lazySpin 0.7s linear infinite'
        }} />
        <style>{`@keyframes lazySpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
);

const withSuspense = (Component) => (props) => (
    <Suspense fallback={<LazyFallback />}>
        <Component {...props} />
    </Suspense>
);

// Páginas Públicas Secundarias (Code Splitting con lazy loading)
const PageDetail = withSuspense(lazy(() => import('../Pages/PageDetail/PageDetail')));
const PageTienda = withSuspense(lazy(() => import('../Pages/PageTienda/PageTienda')));
const TiendasPage = withSuspense(lazy(() => import('../Pages/TiendasPage/TiendasPage')));
const TiendasCategoriaPage = withSuspense(lazy(() => import('../Pages/TiendasCategoria/TiendasCategoria')));
const PublicBooking = withSuspense(lazy(() => import("./PublicBooking/PublicBooking")));
const ActivarCuenta = withSuspense(lazy(() => import("./ActivarCuenta/ActivarCuenta")));
const PageEvento = withSuspense(lazy(() => import("./PageEvento/PageEvento")));
const PageEventos = withSuspense(lazy(() => import("./PageEventos/PageEventos")));

// Páginas del Panel Administrativo (Lazy loading para no sobrecargar a los visitantes de la tienda)
const Main = withSuspense(lazy(() => import("./Main/Main")));
const Productos = withSuspense(lazy(() => import('../Pages/Productos/Productos')));
const Usuarios = withSuspense(lazy(() => import('../Pages/Usuarios/Usuarios')));
const Banners = withSuspense(lazy(() => import("./Banners/Banners")));
const Contacto = withSuspense(lazy(() => import("./Contacto/Contacto")));
const Categorias = withSuspense(lazy(() => import("./Categorias/Categorias")));
const CategoriasTiendas = withSuspense(lazy(() => import("./CategoriasTiendas/CategoriasTiendas")));
const Codigos = withSuspense(lazy(() => import("./Codigos/Codigos")));
const Tiendas = withSuspense(lazy(() => import("./Tiendas/Tiendas")));
const MultiCitas = withSuspense(lazy(() => import("./MultiCitas/MultiCitas")));
const CitasDashboard = withSuspense(lazy(() => import("./CitasDashboard/CitasDashboard")));
const Configuracion = withSuspense(lazy(() => import("./Configuracion/Configuracion")));
const Eventos = withSuspense(lazy(() => import("./Eventos/Eventos")));
const Galeria = withSuspense(lazy(() => import("./Galeria/Galeria")));
const Regiones = withSuspense(lazy(() => import("./Regiones/Regiones")));
const ComandasDashboard = withSuspense(lazy(() => import("./ComandasDashboard/ComandasDashboard")));

const basename = (typeof window !== 'undefined' && window.location.pathname.startsWith('/clubvendemas'))
    ? '/clubvendemas'
    : '';

export const router = createBrowserRouter([
    {
        path: "/",
        element: <IndexLayout />,
    },
    {
        path: "/activar-cuenta",
        element: <ActivarCuenta />,
    },
    {
        path: "/citas/:tenantId",
        element: <PublicBooking />,
    },
    {
        path: "/citas",
        element: <PublicBooking />,
    },
    {
        path: "/agendar/:tenantId",
        element: <PublicBooking />,
    },
    {
        path: "/agendar",
        element: <PublicBooking />,
    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/producto/:idProducto/:producto`,
                element: <PageDetail />,
            },
        ]
    },
    {
        path: "/",
        element: <PageLayaut />,
        children: [
            {
                path: `/tienda/:idTienda/:nombre`,
                element: <PageTienda />,
            },
            {
                path: `/tiendas`,
                element: <TiendasPage />,
            },
            {
                path: `/categoria-tiendas/:idCategoria/:categoria`,
                element: <TiendasCategoriaPage />,
            },
            {
                path: `/categoria-tiendas/:idCategoria`,
                element: <TiendasCategoriaPage />,
            },
            {
                path: `/tiendas/categoria/:idCategoria/:categoria`,
                element: <TiendasCategoriaPage />,
            },
            {
                path: `/tiendas/categoria/:idCategoria`,
                element: <TiendasCategoriaPage />,
            },
            {
                path: `/evento/:idEvento/:titulo`,
                element: <PageEvento />,
            },
            {
                path: `/evento/:idEvento`,
                element: <PageEvento />,
            },
            {
                path: `/eventos`,
                element: <PageEventos />,
            },
            {
                path: `/:slugTienda`,
                element: <PageTienda />,
            },
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },
            {
                path: `/dashboard/configuracion`,
                element: <Configuracion />,
            },
            {
                path: `/dashboard/multicitas`,
                element: <MultiCitas />,
            },
            {
                path: `/dashboard/citas`,
                element: <CitasDashboard />,
            },
            {
                path: `/dashboard/productos`,
                element: <Productos />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },
            {
                path: `/dashboard/galeria`,
                element: <Galeria />,
            },
            {
                path: `/dashboard/eventos`,
                element: <Eventos />,
            },
            {
                path: `/dashboard/contacto`,
                element: <Contacto />,
            },
            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },
            {
                path: `/dashboard/codigos`,
                element: <Codigos />,
            },
            {
                path: `/dashboard/tiendas`,
                element: <Tiendas />,
            },
            {
                path: `/dashboard/comandas`,
                element: <ComandasDashboard />,
            },
            {
                path: `/dashboard/categorias-tiendas`,
                element: <CategoriasTiendas />,
            },
            {
                path: `/dashboard/regiones`,
                element: <Regiones />,
            },
        ],
    },
], { basename });
